import { UserCode } from 'api3';
import { getDate } from '@app/shared/dateHelper';

/**
 * Determines the status of a device code based on its properties.
 *
 * @param code - The UserCode to evaluate
 * @returns The status of the code: 'logged-out', 'used', 'expired', or 'active'
 */
export const getCodeStatus = (code: UserCode): 'active' | 'used' | 'expired' | 'logged-out' => {
  // Check if logged out (server state)
  if (code.isLoggedOut) return 'logged-out';
  if (code.usedAt) return 'used';

  const creationTime = getDate(code.createdAt);
  if (!creationTime) return 'expired';

  const expiryTime = new Date(creationTime.getTime() + 60 * 60 * 1000);
  const expiryTimeIsInThePast = expiryTime < new Date();
  return expiryTimeIsInThePast ? 'expired' : 'active';
};
